import { AccountState } from "./accountState";

export function getUserName(user: User | undefined) {
  if (user === undefined) return "undefined";
  if (user.__t === "User") return `${user.firstName} ${user.lastName}`;
  else return user.name;
}

export function getUserType(user: User) {
  return user.__t === "User" ? (user.teacher ? "استاد" : "کاربر") : "سازمان";
}

export type User = {
  _id: string;
  __t: "User" | "Organ";
  phone: string;
  profile?: string;
  accountState: AccountState;
  isAdmin: boolean;
  name: string;
  firstName: string;
  lastName: string;
  teacher: boolean;
  commision: number;
  desc: string;
};

export type Organ = {
  _id: string;
  __t: "Organ";
  phone: string;
  accountState: AccountState;

  profile?: string;

  desc: string;

  wallet: number;
  name: string;
};

export type Member = {
  _id: string;
  phone: string;
  profile?: string;
  userName: string;
};
